export default __webpack_public_path__ + "static/media/sp-cs-range-eq.c37ad897.png";